import { applyCspNonceToElement } from './getCspNonce';

/**
 * Replaces the content of a dedicated <style> element (CSP style-src-attr 'none' safe).
 * Uses csp-nonce meta when present (see getCspNonce).
 */
export function setCspSafeStyleBlock(elementId, cssText) {
  if (typeof document === 'undefined') return;
  let el = document.getElementById(elementId);
  if (!el) {
    el = document.createElement('style');
    el.id = elementId;
    applyCspNonceToElement(el);
    document.head.appendChild(el);
  }
  el.textContent = cssText ?? '';
}
